<template>
<div style="padding: 20px">
	<div class="Section0" style="layout-grid:15.6000pt;">
		<p class=MsoNormal align=center style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:center;"><b><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:16.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">个人信息处理授权协议</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-weight:bold;font-size:16.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<font face="宋体">更新日期：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">2022年3月2日</span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<font face="宋体">版本日期：</font>
				<font face="宋体">2</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">022</span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<font face="宋体">年</font>
				<font face="宋体">3月2日</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">《</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">个人信息处理授权协议》</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">（以下</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">简称</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">本协议</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">）</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">将</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">说明</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">众诚汽车保险股份有限公司（以下简称众诚保险或我们）如何在</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">遵循合法、正当、必要和诚信原则的前提下处理和保护您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">（投保人、被保险人、受益人）</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的个人信息。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.1000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">在</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">您确认签署本协议之前，请您务必仔细阅读本协议的所有内容。如</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">您</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">签署本协议，即</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">表明</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">您已充分理解本协议的</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">含义</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">及</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">其</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">法律后果，并且同意接受本协议的约束；如您不同意本协议中的任一条件，请勿签署投保众诚保险的任何产品，同时不要</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">向</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">我们提供您的个人信息。</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.1000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">请注意</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">，本协议不面向未满</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">18周岁</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">的未成年</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">人</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">使用</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">；</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">如您未满</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">18周岁</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">，请勿签署本协议，不要向我们提供个人信息</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">。</font>
				</span></b><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">如果</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">发现在</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">未事先获得父母或其他监护人同意的前提下</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">收集</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">了未满</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">18周岁的未</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">成年</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的个人信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">我们将立即删除。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">同时</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">停止向</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">其</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">提供众诚保险相关产品服务或者取消</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">其</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的投保资格。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">如</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您对本协议有任何疑问，可以按照如下方式联系我们：</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.1000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">个人</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">信息</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">处理</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">者</font>
				</span></b><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">：</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">众诚汽车</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">保险股份有限公司</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.1000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">联系</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">地址</font>
				</span></b><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">：广东省</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">广州</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">市</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">天河</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">区</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">广州大道中</font>
				<font face="仿宋">9</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">88</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">号圣丰广场</font>
				<font face="仿宋">1</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">3</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">楼</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.1000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">联系方式</font>
				</span></b><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">：</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">众诚保险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">官网、</font>“
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">众诚保险</font>
				<font face="仿宋">”微信公众号在线</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">客服或拨打</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">4</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">008600600</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">客服</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">电话</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">与</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">我们联系</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.1000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">一、</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">定义</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">本协议</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">中专业名词与《</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">中华</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">人民共和国个人信息保护法》</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">中</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的定义保持一致。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.1000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">二、</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">众诚保险如何收集和使用您的个人信息</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">（一）众诚保险收集个人信息的方式</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">众诚保险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">基于向您提供保险产品和服务之必要</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，我们将通过如下方式向您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">收集</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">个人信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">：</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">1.</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">由您主动向我们提供；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">2.由</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">使用</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">我们提供的产品或服务过程中自动生成；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">3.我们</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">经由您授权同意或者我们履行法律义务所需向第三方收集、查询、获取的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">个人信息，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">并</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">基于特定目的范围内处理这些个人信息。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">（二）众诚保险收集您个人信息的具体内容</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.2500pt;mso-char-indent-count:2.0200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">请您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">注意，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">众诚保险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">基于向您提供保险产品和服务之必要</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">需</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">提交您的必要个人信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">可能</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">还</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">需要由您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">提交</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">由于保险产品或者服务</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">特殊性所需的关联个人（</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">包括</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">但不限于</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">被</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">保险人、受益人）</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">个人信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">。</font>
			</span><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">请您</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">确保</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">，在您</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">向</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">我们提供关联个人的个人信息前，</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">务必事先征得其同意</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">由我们处理其个人信息。</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">如您属于政府</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">企事业单位等法人组织或者社会团体等非法人组织</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，为</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您的组织成员或者近</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">亲属</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">作为您、</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">或作为</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">受益人投保</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">众诚</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">保险产品，基于</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">保险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">产品或者服务</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">需要，我们将</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">收集相关投保人、被保险人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、受益人的个人信息。</font>
			</span><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">请您</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">确保</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">，在您</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">向</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">我们提供关联个人的个人信息前，</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">务必征得其同意</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">由我们处理其个人信息。</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">1．为了</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">识别、验证和确定您的真实身份，确定您申请投保的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">保险标的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">状况，众诚保险需要收集您的个人基本资料，包括姓名、</font>
			</span><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">手机号码</font>
				</span></b><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、电子邮箱、</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">生日</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">；您的个人身份信息，包括</font>
			</span><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">身份证、身份证影</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">印</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">件</font>
				</span></b><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">银行账户信息（</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">开户行、</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">账号）</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">第</font>
				<font face="仿宋">1条</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">所涉个人信息将用于与您订立或者续签保险合同</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">履行保险合同项下的各项义务</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">包括在订立或者续签保险合同前判断您是否符合投保条件、完成保险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">合同</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的签署，在履行合同过程中与您取得必要的联系，以及对您进行保后管理或者向您追索到期债务等必要情形。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">2</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">．</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">为了履行保险公司对保险销售行为可</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">回溯</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">管理法定义务，众诚保险将在对您开展互联网销售业务时，将网页浏览点击的过程进行</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">记录</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">或者</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">记录</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您的浏览点击日志数据</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">并相应备份存档；在</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">开展部分业务时</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，基于前述法定义务，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">有可能</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">还需要您的</font>
			</span><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">人脸面部特征信息</font>
				</span></b><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">众诚保险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">将</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">采取</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">充分的技术和管理措施</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">妥善</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">保存您的个人信息，并仅在接受保险销售行为可回溯管理监管时向主管部门提供上述记录，而不会作为其他用途</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">3</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">．</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">为了</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">履行</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">健全反洗钱</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">内部</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">控制制度</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">客户尽职调查制度、客户身份资料和交易记录</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">保存</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">制度等法定义务，提高风险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">监测</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">与识别处置能力</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">众诚保险需要收集您的银行账户信息（</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">包括开户行、账户</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">名称）</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">4</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">．为判断</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">是否符合投保条件、完成保险合同签署所必需，根据您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">投保</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的不同类型的保险产品，您需要提供如下信息：</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">（</font>
				<font face="仿宋">1）车险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">：车辆基本信息（</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">车牌</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">号码、车辆识别码、发</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">动</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">机</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">号</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、初次登记日期、品牌型号等）</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">投保信息（</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">险种</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、保险金额）</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">为</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">按照</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">监管平台要求收集以用于和监管平台实时交互，众诚保险可能需要收集您的面部识别特征。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">（</font>
				<font face="仿宋">2）其他</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">财产险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">：</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">投</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">保人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、被保险人信息（</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">包括企业</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">名称、地址、个人姓名、证件号码</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">职业类别</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">等</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">）</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">投保信息（</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">包括</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">投保金额、财产标的等）</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">（</font>
				<font face="仿宋">3）本公司经营范围内的其他人身保险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">：投</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">保人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、被保险人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">及</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">受益人基本信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">（包括</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">姓名、性别、地址、联系方式、证件号码等）</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">投保</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">健康</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">险时、您还需要提供您的健康</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">情况</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">材料并授权我们从第</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">三方</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">查询和收集个人信息，包括但不限于从健康管理</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">服务</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">提供方、医疗机构处查询和收集您的健康状况、就医记录等个人信息。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">5．</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">知悉</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">并理解，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">当</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您申请或者</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">接受</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">
					众诚保险提供的保险产品或者服务时，为了确保交易安全，建立您的客户档案，在法律法规及监管规定允许的范围内，我们可能基于您的授权向我们的关联公司间接收集您的部分个人基本资料和个人身份信息，以确认和核验您作为众诚保险客户的真实身份，补充丰富您作为众诚保险的客户资料，并在您主动选择或者
				</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">接受</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">时提供您所需要的定制化产品和服务</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">6</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">．</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">&nbsp;</span><b
				style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">单独同意</font>
				</span></b><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您确认</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">&nbsp;&nbsp;&nbsp;</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">同意</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">&nbsp;&nbsp;&nbsp;</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">不同意如下事项：在您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">接受</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">众诚保险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">所提供的保险服务过程中，我们可能会基于您提供的联系方式（</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">手机号码</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、邮箱地址）</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，</font>
			</span><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">向您提供适合您的产品、服务电话或者</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">短信</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">推荐消息</font>
				</span></b><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，或者基于您所提供的信息对您开展市场调研和服务满意度调查，以改善和优化向您提供的产品和服务体验。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">如您勾选同意后，在接到信息或调研需求当时改变主意，也可以致电</font>
				<font face="仿宋">4</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">008600600</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">取消同意授权。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">7</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">. 例外情形</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:28.0000pt;mso-char-indent-count:2.0000;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">我们</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">在</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">以下</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">情形中收集、使用您的以下</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">个人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">信息无需征得您的授权同意：</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l1 level1 lfo1;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（1）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">与个人信息控制者履行法律法规规定的义务相关的；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l1 level1 lfo1;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（2）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">与国家安全、国防安全直接相关的；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l1 level1 lfo1;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（3）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">与公共安全、公共卫生、重大公共利益直接相关的；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l1 level1 lfo1;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（4）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">与刑事侦查、起诉、审判和判决执行等直接相关的；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l1 level1 lfo1;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（5）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l1 level1 lfo1;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（6）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">所涉及的个人信息是个人信息主体自行向社会公众公开的；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l1 level1 lfo1;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（7）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">根据个人信息主体要求签订和履行合同所必需的；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l1 level1 lfo1;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（8）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l1 level1 lfo1;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（9）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l1 level1 lfo1;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（10）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">履行金融机构反洗钱法定义务以及</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">保险销售行为可</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">回溯</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">管理</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">等监管要求的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">法定义务</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l1 level1 lfo1;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（11）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">其他法律法规等规定的情形。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.8000pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">三</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">、众诚保险</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">如何</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">委托处理、共享或者对外提供您的个人信息</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">为</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">更好地向您提供相关保险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">产品</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">服务及您权益，众诚保险将基于以下特定</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">目的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，委托技术和数据分析服务提供商或者其他合作第三方处理您的以下特定信息：</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-right:-2.8500pt;margin-bottom:5.0000pt;
mso-para-margin-right:-0.2700gd;mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-indent:36.6500pt;mso-char-indent-count:2.6200;mso-pagination:widow-orphan;
text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">1</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">.</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">当您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">申请</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">或者接受众诚保险提供的保险产品</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">或者</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">服务时，为了</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">帮助</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">我们</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">提升</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">核保</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">模型</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">精度与</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">准确性，提高保险风险内控水平、完善风控模型</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">我们需要将您的个人信息委托我们的第三方技术服务提供商进行测试分析、建模研究和效果分析，以确保向您提供产品的服务的安全性和稳定性。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">2</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">.</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">当您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">申请</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">理赔</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">报案</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">服务时，为</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">了</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">向您履行提供出险和理赔合同义务，并顺利完成理赔支付，众诚保险将委托</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">经纪</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">公司、保险公估公司、咨询公司、鉴定检测机构、残值服务商</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、</font>
				<font face="仿宋">TPA服务商、延保服务商等其他理赔服务商</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">或者共保公司提供事故现场出险、事故定损评估或鉴定等技术性服务，他们可能会基于理赔服务所必要</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">接受众诚保险的委托处理</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">分析和使用您接受理赔服务相关的部分个人信息。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">3</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">.基于</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">向您提供众诚保险各项产品或者服务、履行法定义务所必要，众诚保险委托服务提供商或者其他合作第三方提供技术和</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">专业</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">服务的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">必要</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">情形。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">除上述</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">外，以下情况中众诚保险可能将</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">共享</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">或者对外提供您的个人信息：</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">1.</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">当您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">申请或者接受众诚保险与其他保险公司所共同提供的保险产品和服务（</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">“共保</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">产品</font>”）
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">或</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">再保险服务时，众诚保险需要依据本协议收集的个人信息与提供</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">共保</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">产品或者服务或再保险服务的其他保险公司共享（</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">提供</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">共保产品或者服务或再保险服务的其他保险公司的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">名称</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、联系方式请见本协议的主合同）</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">以向您提供由众诚保险和其他保险公司共同提供的保险产品或者服务或再保险服务。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">2.</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">当您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">在理赔</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">服务阶段</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">因事故纠纷或保险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">争端</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">解决、</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">行政</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">执法或者司法诉讼等，众诚保险或将基于相关主管部门、公安</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">司法部门等</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">有权</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">机关的要求，或将基于推进保险服务相关争议解决的需要，将您的部分个人信息提供给</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">前述</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">有权机关，以实现相应的行政司法要求和纠纷解决需求。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">3</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">.根据</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您投保的保险产品，我们</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">可能</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">会向您提供与保险合同相关服务，如道路救援服务</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">健康管理服务等，具体服务形式以保险合同载明为准。为</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">提供</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">此类服务，我们</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">可能</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">需要您提供与使用服务相关的信息并授权我们共享给第三方服务供应商，以使</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">获得更好的客户体验。具体</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">内容</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">以您后续使用第三方服务时的单独</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">授权</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">条款为准。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">请您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">注意，根据相关可适用的法律法规，以下情形中，众诚保险共享、转让、公开披露您个人信息无需事先征得您的授权同意：</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l2 level1 lfo2;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（1）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">与众诚保险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">履行</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">法律法规规定的义务相关的，如根据有关监管规定，将与您申请或使用我们的产品、服务有关的信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">和</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您的其他相关信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">向</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">监管机构、行业自律组织、监管信息系统等有权主管部门或第三方报送信息的；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l2 level1 lfo2;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（2）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">与国家</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">安全、国防安全直接相关的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l2 level1 lfo2;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（3）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">与公共安全、公共卫生、重大公共利益直接相关的；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l2 level1 lfo2;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（4）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">与刑事侦查、起诉、审判和判决执行等直接相关的；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l2 level1 lfo2;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（5）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">出于</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">个人的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">生命</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、财产等重大</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">合法</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">权益但又很难得到其授权同意的；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l2 level1 lfo2;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（6）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您及关联个人自行向社会公众公开的个人信息；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l2 level1 lfo2;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（7）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">从合法公开披露的信息中收集个人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的，如合法的新闻报道、政府信息公开等渠道</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.8000pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">四</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">、众诚保险</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">如何</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">存储您的个人信息</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">我们</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">在中华人民共和国境内</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">收集</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">和产生的个人信息，存储于中华人民共和国境内。除</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">法律</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、行政法规另有规定外，众诚保险将在实现处理目的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">所必要</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的最短时间内留存您的个人信息。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">众诚保险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">将依照法律要求和行业</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">惯例</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，采取必要的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">安全</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">技术和管理措施，如将个人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">去标识化，脱敏存储和加密传输，设置公司</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">系统访问权限隔离，采纳调取访问客户信息前的授权审批管理，以及对系统用户权限进行定期监督审计等，以</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">预防</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">任何个人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">遭到泄露、篡改</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">丢失</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">或者</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">未经授权的访问等安全事件的发生。我们</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">将</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">针对处理敏感个人信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">利用个人信息进行自动化决策，委托处理个人信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">向其他</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">个人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">提供</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">个人信息、公开个人信息，向</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">境外</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">提供个人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">等对您的个人权益</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">可能</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">有重大影响的个人信息处理活动，就处理目的、处理方式等是否合法、正当、必要，对个人权益的影响及</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">安全</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">风险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">所采取的保护</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">措施</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">是否合法、有效并</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">与</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">风险程度相适应等事项，开展事前个人信息保护影响评估，并将评估报告和处理情况</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">记录</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">予以保存。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.8000pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">五</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">、众诚保险如何跨境提供您的个人信息</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">如</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">众诚保险因业务需要，确需向境外传输您的个人信息，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">我们</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">会遵循法律法规和相关监管部门的要求，向您告知境外接收方的名称或者姓名</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、联系</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">方式、处理目的、处理方式、个人信息的种类以及</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">可向境外接收方</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">行使相关</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">权利的方式和程序等事项，并取得您的明确</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">同意</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">。此外</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">在向境外提供您的个人信息前，我们会通过安全评估、经专业机构</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">进行</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">个人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">保护</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">认证</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、或者按照国家网信</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">部门</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">制定的标准合同与境外接收方订立合同等方式，以达到向境外提供个人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的条件。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.8000pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">六、您</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">如何行使个人信息权利</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">如</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您有以下需求，可通过</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">众诚保险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">官网、</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">“众诚保险”微信公众号在线</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">客服或拨打</font>4008600600
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">热线</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">与我们联系，我们已经建立客户个人行使权利的申请受理和处理机制，我们将在收到您的申请后的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">15天</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">内尽快</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">作出</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">答复。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">1</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">．</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">查阅、复制、</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">更正</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">或者补充您的个人信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">2</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">. 有下列情形之一的，您</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">有权</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">请求众诚保险删除您的个人信息：</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l0 level1 lfo3;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（1）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">个人信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">处理目的已实现、无法实现或者为实现处理目的不再必要；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l0 level1 lfo3;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（2）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">众诚保险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">停止向您提供产品或者服务，或者保存期限已届满；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l0 level1 lfo3;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（3）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">基于同意</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">处理个人信息、且您已主动撤回同意</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l0 level1 lfo3;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（4）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">众诚保险</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">违反法律、行政法规或者违反约定处理您的个人信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">；</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=27 style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:0.0000pt;
mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:28.3500pt;
mso-char-indent-count:0.0000;mso-pagination:widow-orphan;text-align:left;
mso-list:l0 level1 lfo3;">
			<span style="font-family:仿宋;mso-bidi-font-family:宋体;color:rgb(0,0,0);
font-size:14.0000pt;mso-font-kerning:0.0000pt;"><span style='mso-list:Ignore;'>（5）<span>&nbsp;</span></span></span>
			<span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">法律</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、行政法规规定的其他情形</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span>
		</p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">3</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">．</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">本协议中经由您同意而</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">收集</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的个人信息及其处理活动，您可以向众诚保险要求撤回</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">前述</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">授权。但</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">请您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">同时留意，撤回同意不影响撤回前基于</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">同意已进行的个人信息处理活动的效力。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">4</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">．</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">要求众诚保险对个人信息处理规则进行</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">解释</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">说明。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">5</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">．您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">可以以书面形式对您的个人信息进行生前安排。根据</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">相关</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">法律要求，您的近亲属可以基于合法、正当利益，通过本协议中公布的联系方式要求对您生后的个人信息行使查阅、复制、更正、删除等权利；但您通过本条中的方式告知您另有安排的除外。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.8000pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">七、</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<font face="仿宋">本协议的更新、法律解释与适用</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">众诚保险可能</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">适时修订本协议，一旦本协议内容</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">发生</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">变更，众诚保险将通过合理的方式与您取得联系，并通过</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">公众号弹窗</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">提示、官网发布公告等显著的方式通知您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">其</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">中</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">，针对个人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的处理目的、处理方式</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">和个人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">种类</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">发生变更的，我们会重新取得您的明确同意。若</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">不同意修改后的个人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">保护政策，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">有权并应立即停止使用众诚保险服务。针对除</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">个人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">信息</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">处理目的、处理方式和</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">个人</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">信息种类变更以外的其他事项，若您</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">在</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">本协议修订后继续使用众诚保险提供的产品或服务，这</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">表示</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">您已充分</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">阅读</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">、理解并愿意</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">受</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">修订条款的约束。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;text-indent:36.6500pt;mso-char-indent-count:2.6200;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">本协议</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">的成立、生效、履行、解释及纠纷解决，</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">适用</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">中华人民共和国法律法规（</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">但</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">不包括冲突规则）</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">因</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">本协议</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">发生纠纷的，您同意将纠纷提交被告所在地有管辖权的</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">人民</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<font face="仿宋">法院处理。</font>
			</span><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p>&nbsp;</o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b style="mso-bidi-font-weight:normal"><span
					style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);mso-ansi-font-weight:bold;font-size:14.0000pt;
mso-font-kerning:0.0000pt;">
					<o:p>&nbsp;</o:p>
				</span></b></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:仿宋;mso-bidi-font-family:宋体;
color:rgb(0,0,0);font-size:14.0000pt;mso-font-kerning:0.0000pt;">
				<o:p>&nbsp;</o:p>
			</span></p>
	</div>
	</div>
</template>

<script>
// 此页面为 word 文档导出页面
export default {
  data() {
    return {

    };
  },
  async mounted() {

  },
  methods: {
  }
};
</script>

<style lang="scss">
		@font-face {
			font-family: "Times New Roman";
		}

		@font-face {
			font-family: "宋体";
		}

		@font-face {
			font-family: "等线";
		}

		@font-face {
			font-family: "Wingdings";
		}

		@font-face {
			font-family: "仿宋";
		}

		@list l0:level1 {
			mso-level-number-format: decimal;
			mso-level-suffix: tab;
			mso-level-text: "（%1）";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 56.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l0:level2 {
			mso-level-number-format: alpha-lower;
			mso-level-suffix: tab;
			mso-level-text: "%2)";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 77.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l0:level3 {
			mso-level-number-format: lower-roman;
			mso-level-suffix: tab;
			mso-level-text: "%3.";
			mso-level-tab-stop: none;
			mso-level-number-position: right;
			margin-left: 98.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l0:level4 {
			mso-level-number-format: decimal;
			mso-level-suffix: tab;
			mso-level-text: "%4.";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 119.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l0:level5 {
			mso-level-number-format: alpha-lower;
			mso-level-suffix: tab;
			mso-level-text: "%5)";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 140.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l0:level6 {
			mso-level-number-format: lower-roman;
			mso-level-suffix: tab;
			mso-level-text: "%6.";
			mso-level-tab-stop: none;
			mso-level-number-position: right;
			margin-left: 161.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l0:level7 {
			mso-level-number-format: decimal;
			mso-level-suffix: tab;
			mso-level-text: "%7.";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 182.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l0:level8 {
			mso-level-number-format: alpha-lower;
			mso-level-suffix: tab;
			mso-level-text: "%8)";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 203.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l0:level9 {
			mso-level-number-format: lower-roman;
			mso-level-suffix: tab;
			mso-level-text: "%9.";
			mso-level-tab-stop: none;
			mso-level-number-position: right;
			margin-left: 224.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l1:level1 {
			mso-level-number-format: decimal;
			mso-level-suffix: tab;
			mso-level-text: "（%1）";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 21.0000pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l1:level2 {
			mso-level-number-format: alpha-lower;
			mso-level-suffix: tab;
			mso-level-text: "%2)";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 42.0000pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l1:level3 {
			mso-level-number-format: lower-roman;
			mso-level-suffix: tab;
			mso-level-text: "%3.";
			mso-level-tab-stop: none;
			mso-level-number-position: right;
			margin-left: 63.0000pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l1:level4 {
			mso-level-number-format: decimal;
			mso-level-suffix: tab;
			mso-level-text: "%4.";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 84.0000pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l1:level5 {
			mso-level-number-format: alpha-lower;
			mso-level-suffix: tab;
			mso-level-text: "%5)";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 105.0000pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l1:level6 {
			mso-level-number-format: lower-roman;
			mso-level-suffix: tab;
			mso-level-text: "%6.";
			mso-level-tab-stop: none;
			mso-level-number-position: right;
			margin-left: 126.0000pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l1:level7 {
			mso-level-number-format: decimal;
			mso-level-suffix: tab;
			mso-level-text: "%7.";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 147.0000pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l1:level8 {
			mso-level-number-format: alpha-lower;
			mso-level-suffix: tab;
			mso-level-text: "%8)";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 168.0000pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l1:level9 {
			mso-level-number-format: lower-roman;
			mso-level-suffix: tab;
			mso-level-text: "%9.";
			mso-level-tab-stop: none;
			mso-level-number-position: right;
			margin-left: 189.0000pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l2:level1 {
			mso-level-number-format: decimal;
			mso-level-suffix: tab;
			mso-level-text: "（%1）";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 56.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l2:level2 {
			mso-level-number-format: alpha-lower;
			mso-level-suffix: tab;
			mso-level-text: "%2)";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 77.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l2:level3 {
			mso-level-number-format: lower-roman;
			mso-level-suffix: tab;
			mso-level-text: "%3.";
			mso-level-tab-stop: none;
			mso-level-number-position: right;
			margin-left: 98.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l2:level4 {
			mso-level-number-format: decimal;
			mso-level-suffix: tab;
			mso-level-text: "%4.";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 119.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l2:level5 {
			mso-level-number-format: alpha-lower;
			mso-level-suffix: tab;
			mso-level-text: "%5)";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 140.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l2:level6 {
			mso-level-number-format: lower-roman;
			mso-level-suffix: tab;
			mso-level-text: "%6.";
			mso-level-tab-stop: none;
			mso-level-number-position: right;
			margin-left: 161.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l2:level7 {
			mso-level-number-format: decimal;
			mso-level-suffix: tab;
			mso-level-text: "%7.";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 182.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l2:level8 {
			mso-level-number-format: alpha-lower;
			mso-level-suffix: tab;
			mso-level-text: "%8)";
			mso-level-tab-stop: none;
			mso-level-number-position: left;
			margin-left: 203.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		@list l2:level9 {
			mso-level-number-format: lower-roman;
			mso-level-suffix: tab;
			mso-level-text: "%9.";
			mso-level-tab-stop: none;
			mso-level-number-position: right;
			margin-left: 224.3500pt;
			text-indent: -21.0000pt;
			font-family: 'Times New Roman';
		}

		p.MsoNormal {
			mso-style-name: 正文;
			mso-style-parent: "";
			margin: 0pt;
			margin-bottom: .0001pt;
			mso-pagination: none;
			text-align: justify;
			text-justify: inter-ideograph;
			font-family: 等线;
			mso-bidi-font-family: 'Times New Roman';
			font-size: 10.5000pt;
			mso-font-kerning: 1.0000pt;
		}

		span.10 {
			font-family: 等线;
		}

		span.15 {
			font-family: 等线;
			font-size: 10.5000pt;
		}

		span.16 {
			font-family: 等线;
			font-size: 9.0000pt;
		}

		span.17 {
			font-family: 等线;
			font-size: 9.0000pt;
		}

		span.18 {
			font-family: 等线;
		}

		span.19 {
			font-family: 等线;
			font-weight: bold;
		}

		span.20 {
			font-family: 等线;
			font-size: 9.0000pt;
		}

		p.MsoFooter {
			mso-style-name: 页脚;
			mso-style-noshow: yes;
			margin: 0pt;
			margin-bottom: .0001pt;
			layout-grid-mode: char;
			mso-pagination: none;
			text-align: left;
			font-family: 等线;
			mso-bidi-font-family: 'Times New Roman';
			font-size: 9.0000pt;
			mso-font-kerning: 1.0000pt;
		}

		p.MsoAcetate {
			mso-style-name: 批注框文本;
			mso-style-noshow: yes;
			margin: 0pt;
			margin-bottom: .0001pt;
			mso-pagination: none;
			text-align: justify;
			text-justify: inter-ideograph;
			font-family: 等线;
			mso-bidi-font-family: 'Times New Roman';
			font-size: 9.0000pt;
			mso-font-kerning: 1.0000pt;
		}

		p.MsoCommentText {
			mso-style-name: 批注文字;
			mso-style-noshow: yes;
			margin: 0pt;
			margin-bottom: .0001pt;
			mso-pagination: none;
			text-align: left;
			font-family: 等线;
			mso-bidi-font-family: 'Times New Roman';
			font-size: 10.5000pt;
			mso-font-kerning: 1.0000pt;
		}

		p.MsoHeader {
			mso-style-name: 页眉;
			mso-style-noshow: yes;
			margin: 0pt;
			margin-bottom: .0001pt;
			border-bottom: 1.0000pt solid windowtext;
			mso-border-bottom-alt: 0.7500pt solid windowtext;
			padding: 0pt 0pt 1pt 0pt;
			layout-grid-mode: char;
			mso-pagination: none;
			text-align: center;
			font-family: 等线;
			mso-bidi-font-family: 'Times New Roman';
			font-size: 9.0000pt;
			mso-font-kerning: 1.0000pt;
		}

		p.MsoCommentSubject {
			mso-style-name: 批注主题;
			mso-style-noshow: yes;
			mso-style-parent: 批注文字;
			mso-style-next: 批注文字;
			margin: 0pt;
			margin-bottom: .0001pt;
			mso-pagination: none;
			text-align: left;
			font-family: 等线;
			mso-bidi-font-family: 'Times New Roman';
			font-weight: bold;
			font-size: 10.5000pt;
			mso-font-kerning: 1.0000pt;
		}

		p.p {
			mso-style-name: "普通\(网站\)";
			mso-style-noshow: yes;
			margin-top: 5.0000pt;
			margin-bottom: 5.0000pt;
			mso-margin-top-alt: auto;
			mso-margin-bottom-alt: auto;
			mso-pagination: widow-orphan;
			text-align: left;
			font-family: 宋体;
			font-size: 12.0000pt;
		}

		p.27 {
			mso-style-name: "List Paragraph";
			margin: 0pt;
			margin-bottom: .0001pt;
			text-indent: 21.0000pt;
			mso-char-indent-count: 2.0000;
			mso-pagination: none;
			text-align: justify;
			text-justify: inter-ideograph;
			font-family: 等线;
			mso-bidi-font-family: 'Times New Roman';
			font-size: 10.5000pt;
			mso-font-kerning: 1.0000pt;
		}

		span.msoIns {
			mso-style-type: export-only;
			mso-style-name: "";
			text-decoration: underline;
			text-underline: single;
			color: blue;
		}

		span.msoDel {
			mso-style-type: export-only;
			mso-style-name: "";
			text-decoration: line-through;
			color: red;
		}

		table.MsoNormalTable {
			mso-style-name: 普通表格;
			mso-style-parent: "";
			mso-style-noshow: yes;
			mso-tstyle-rowband-size: 0;
			mso-tstyle-colband-size: 0;
			mso-padding-alt: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;
			mso-para-margin: 0pt;
			mso-para-margin-bottom: .0001pt;
			mso-pagination: widow-orphan;
			font-family: 'Times New Roman';
			font-size: 10.0000pt;
			mso-ansi-language: #0400;
			mso-fareast-language: #0400;
			mso-bidi-language: #0400;
		}

		@page {
			mso-page-border-surround-header: no;
			mso-page-border-surround-footer: no;
		}

		@page Section0 {
			margin-top: 72.0000pt;
			margin-bottom: 72.0000pt;
			margin-left: 90.0000pt;
			margin-right: 90.0000pt;
			size: 595.3000pt 841.9000pt;
			layout-grid: 15.6000pt;
			mso-header-margin: 42.5500pt;
			mso-footer-margin: 49.6000pt;
		}

		div.Section0 {
			page: Section0;
		}
	</style>
